import service from '@/utils/request-base'
import axios from 'axios'

// 通过openid 获取用户的lenovoid、userSign，用于TXIM login
export function getUserLoginSign(openid) {
  return service({
    url: `/api/csc/ucenter/getLenovoid?openid=${openid}`,
    method: 'get'
  })
}
// 获取签名
export function getSign() {
  return service({
    url: `/api/csc/ucenter/userSig`,
    method: 'get'
  })
}
// 获取用户信息
export function getUserInfo() {
  return service({
    url: `/api/csc/ucenter/info`,
    method: 'get'
  })
}
// 获取七牛上传token
export function getQiniuUpToken() {
  return service({
    url: '/api/wb/qiniu/token',
    method: 'post'
  })
}
// 开启机器人
export function startRobot({ channel }) {
  return service({
    url: `/api/csc/robot/start`,
    method: 'get',
    params: { channel }
  })
}
// 关闭机器人
export function closeRobot({ channel, openid }) {
  return service({
    url: `/api/csc/robot/close`,
    method: 'get',
    params: { channel, openid }
  })
}
// 创建会话
export function createSession() {
  return service({
    url: '/api/csc/createSession',
    method: 'get'
  })
}
// 大队列点选
export function toBigQueue(para) {
  return service({
    url: `api/csc/queue/selectBigQueue`,
    method: 'post',
    data: para
  })
}
// 工程师点选
export function selectPersonal(para) {
  return service({
    url: `/api/csc/queue/selectPersonal`,
    method: 'post',
    data: para
  })
}

// 获取产线服务时间
export function getProductLine(accessName = 'webchat') {
  return service({
    url: `/api/csc/production/line/list?accessName=${accessName}`,
    method: 'get'
  })
}
// 获取产线下可点选工程师
export function getEngineerList({ skill, openid }) {
  return service({
    url: `/api/csc/queue/click/engineerList`,
    method: 'get',
    params: { skill, openid }
  })
}
// 发送消息
export function postMessageBody(params) {
  return service({
    url: `/api/csc/core/webchat/main`,
    method: 'post',
    data: params
  })
}
// 获取用户session列表
export function getHistoryList() {
  return service({
    url: `/api/csc/session/c/sessionList`,
    method: 'get'
  })
}
// 获取聊天记录
export function getHistoryMsg(sessionId) {
  return service({
    url: `/api/csc/session/c/messages/${sessionId}`,
    method: 'get'
  })
}
// 获取用户当前会话状态
export function getCurrentStatus(params) {
  return service({
    url: `/api/csc/ucenter/currentStatus`,
    method: 'get',
    params,
    doNotCheck: true
  })
}

// 用户端验证某位工程师状态
export function getPersonnalStatus(params) {
  return service({
    url: `/api/csc/queue/personnalStatus`,
    method: 'post',
    data: params,
    doNotCheck: true
  })
}
// 获取队列服务时间
export function getQueueServiceTime(code) {
  return service({
    url: `api/csc/session/getQueueDescription?code=${code}`,
    method: 'get'
  })
}
// 获取队列
export function getQueue(code) {
  return service({
    url: `/api/wb/queue`,
    method: 'get'
  })
}
// 关闭会话
export function closeSession(sessionId) {
  return service({
    url: `/api/csc/session/userclose`,
    method: 'get',
    params: {
      session_id: sessionId
    }
  })
}
// 退出排队
export function exitQueue(para) {
  return service({
    url: `/api/csc/queue/exit?cubeUID=${para.cubeUID}&skill=${para.skill}`,
    method: 'get'
  })
}

// 图片上传
export function uploadImage(params) {
  return axios.post(`/api/csc/upload/image?token=${params.token}`, params.data)
  // return service({
  //   url: `/api/csc/upload/image?token=${params.token}`,
  //   method: 'post',
  //   data: params.data
  // })
}
// 获取企业信息
export function getCompanyInfo() {
  return service({
    url: `/api/csc/configCompanyInfo`,
    method: 'get'
  })
}
// 公告栏
export function getMaintenance() {
  return service({
    url: `/api/csc/maintenance`,
    method: 'get'
  })
}
// 产线是否有在线工程师接口
export function onlineEngineer({ openid, skill }) {
  return service({
    url: `/api/csc/production/chek/onlineEngineer`,
    method: 'get',
    params: { openid, skill },
    doNotCheck: true
  })
}
// 队列下排队人数
export function awaitUserNumber(params) {
  return service({
    url: `api/csc/queue/awaitUserNumber`,
    method: 'get',
    params
  })
}
// 机器人反馈接口
export function Robotevaluation(params) {
  return service({
    url: `api/csc/robot/evaluation?msgid=${params.msgid}&status=${params.status}`,
    method: 'post',
    data: params
  })
}
export function Robotfeedback(params) {
  return service({
    url: `api/csc/robot/feedback?msgid=${params.msgid}&tag=${params.tag}&suggest=${params.suggest}`,
    method: 'post',
    data: params
  })
}

// 常见问题-【获取】
export function getCommonProblem() {
  return service({
    url: `/api/csc/commonProblem`,
    method: 'get'
  })
}
// 轮播图-【获取】
export function getBanner() {
  return service({
    url: `api/csc/banner`,
    method: 'get'
  })
}
export function uploadFileImage(blobFile) {
  const date = new Date()
  const rand = (Math.random().toString().substr(3, 20) + Date.now()).toString(36)
  const fileType = blobFile.type.split('/')[1]

  const param = new FormData() // 创建form对象
  // param.append('token', qiNiuToken)
  param.append('file', blobFile)
  param.append('key', `cube/Image/${date.getFullYear()}${date.getMonth() + 1}/${rand}.${fileType}`)

  // 添加请求头
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }

  // todo qiNiuHost replace ?
  return new Promise((resolve, reject) => {
    // todo recommend: request method replace axios
    service({
      url: `/api/csc/upload/image`,
      method: 'post',
      data: param,
      contentType: config
    }).then(response => {
      resolve({
        response
      })
    }).catch(err => {
      reject(err)
    })
    // axios({
    //   method: 'POST',
    //   url: `/api/csc/upload/image?token=${sessionStorage.getItem('token')}`,
    //   data: param,
    //   contentType: config
    // }).then(response => {
    //   resolve({
    //     response
    //   })
    // }).catch(err => {
    //   reject(err)
    // })
  })
}

export function uploadFile(file, progress, error) {
  const data = new FormData()
  data.append('file', file, file.name)
  return service({
    url: '/api/csc/upload/file',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data,
    onUploadProgress: function(e) {
      if (progress && e.lengthComputable) {
        const percentComplete = Math.floor((e.loaded / e.total) * 100) / 100
        progress(percentComplete)
      }
    },
    error: function(e) {
      if (error) {
        error(e)
      }
    },
    timeout: 60 * 1000
  })
}
export function downloadFile(src, progress) {
  return service({
    url: src,
    method: 'post',
    responseType: 'blob',
    onDownloadProgress: function(e) {
      if (progress && e.lengthComputable) {
        const percentComplete = Math.round(e.loaded / e.total)
        progress(percentComplete)
      }
    }
  })
}

// 队列下排队人数
export function getProductRelation(params) {
  return service({
    url: `api/csc/good/relation`,
    method: 'get',
    params
  })
}

export function getCustomerRules(token) {
  return service({
    url: `/api/csc/ucenter/customer_rules`,
    method: 'get'
  })
}

// 右侧tap页面接口
// 栏目列表,传ID则获取栏目下分类列表，不传则位栏目列表
export function getSectionList(params) {
  return service({
    url: `/api/csc/webchat/clist`,
    method: 'get',
    params
  })
}

// 栏目列表,传ID则获取栏目下分类列表，不传则位栏目列表
export function getArticleContent(params) {
  return service({
    url: `/api/csc/webchat/get_article_content`,
    method: 'get',
    params
  })
}

// 快速入口接口
export function getFastEntryList(params) {
  return service({
    url: `/api/csc/webchat/fast_entry_list`,
    method: 'get',
    params
  })
}

// 接触记录条件查询
export function getTouchList(data) {
  return service({
    url: `/api/csc/webchat/GetIRListByQC`,
    method: 'post',
    data
  })
}
// 接触记录条件查询
export function getTouchDetail(id, cube_uid) {
  return service({
    url: `/api/csc/webchat/getmessages/${id}?cube_uid=${cube_uid}`,
    method: 'get'
  })
}

// 工单列表查询
export function getTicketList(params) {
  return service({
    url: `/api/csc/webchat/getTicketList`,
    method: 'get',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/chat/index.js